/* eslint-disable @typescript-eslint/no-empty-interface */
import { PageRequest } from '@/core/request/PageRequest';
import { Quiz } from '../Quizzes/Quizzes.types';

export interface QuestionFormValues {
  type: QuestionType;
  description: string;
  optionsAnswer: Array<OptionsAnswer & { key: string }>;
}

// List

export interface ListQuestionsParams extends PageRequest {
  description?: string;
  matrixId?: number;
}

export type QuestionType =
  | 'MULTIPLE_CHOICE_SINGLE_ANSWER'
  | 'MULTIPLE_CHOICE_MULTIPLE_ANSWERS'
  | 'STARS_CLASSIFICATION'
  | 'COMMENTS_BOX';

export enum QuestionTypeEnum {
  SingleAnswer = 'MULTIPLE_CHOICE_SINGLE_ANSWER',
  MultipleAnswers = 'MULTIPLE_CHOICE_MULTIPLE_ANSWERS',
  Classification = 'STARS_CLASSIFICATION',
  Comments = 'COMMENTS_BOX',
}

export interface OptionsAnswer {
  id: number;
  answerOptionSequence: number;
  description: string;
}

export interface OptionsAnswerForm extends OptionsAnswer {
  key: string;
}

export type Question = {
  description: string;
  id: number;
  lowerEnd: string;
  optionsAnswer: OptionsAnswer[];
  questionSequence: number;
  quiz?: Quiz;
  topEnd: string;
  type: QuestionType;
  isNew?: boolean;
};

// Create

export interface CreatQuestionsData {}

// Edit

export interface EditQuestionsData {}
